import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $geoblockPlayerTranslation = combine(i18n.$t, ({ t }) =>
  t('geoblock_title')
)
